export default __webpack_public_path__ + "static/media/badge-att.19cf5e1a.png";